module.exports = __webpack_public_path__ + "static/img/hcp-ladder-brintellix-4-3.052b12c2.png";